import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export default function CheckoutSuccessPage() {
  return (
    <div className="text-center py-12">
      <div className="flex justify-center mb-4">
        <CheckCircle className="h-16 w-16 text-green-500" />
      </div>
      <h1 className="text-2xl font-bold mb-4">Pedido Realizado com Sucesso!</h1>
      <p className="text-gray-600 mb-8">
        Obrigado pela sua compra. Você receberá um email com os detalhes do seu pedido.
      </p>
      <Link
        to="/"
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark"
      >
        Voltar para a Loja
      </Link>
    </div>
  );
}
